export class IotRequestParams {
    constructor(installationId: string, siteId: number) {
        this.installationId = installationId;
        this.siteId = siteId;
    }

    installationId: string;
    siteId: number;
}
